// extracted by mini-css-extract-plugin
module.exports = {"weekDaysSelector":"PB-NyPs41WmhfBeVSQptmg==","RegularButton":"zcxo1C8GHQ0PrryOhZxAMg==","selected":"wBTd3Xxqdp-5TdOs70jbnw=="};